import { Experiment } from '@ms/yammer-data/dist/state/types';
import { useExperimentTreatmentWithoutReporting } from '@ms/yammer-hooks/dist/experiments';
import { isIE } from '@ms/yammer-web-core-ui/dist/util/browserDetector';
import React, { FC } from 'react';

import BrowserEndOfLifeBanner from '../BrowserEndOfLifeBanner';

const IE11GatedContent: FC = ({ children }) => {
  const isIE11EndOfLifeEnabled =
    useExperimentTreatmentWithoutReporting(Experiment.IE11EndOfLifeExperience) === 'enabled';
  const shouldBlockIEWithEndOfLifeMessage = isIE() && isIE11EndOfLifeEnabled;

  const content = shouldBlockIEWithEndOfLifeMessage ? <BrowserEndOfLifeBanner /> : <>{children}</>;

  return content;
};

export default IE11GatedContent;
